import React, { useEffect, useContext } from 'react'
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TransactionRow from 'modules/common/components/TransactionRow';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import MemorandaModal from '../modals/MemorandaModal';
import * as actions from '../action';
import * as c from '../constant';
import ViewFaasModal from '../modals/ViewFaasModal';
import ViewTaxDeclarationModal from '../modals/ViewTaxDeclarationModal';

function Information({ applicationInfo, getSingleTransactCode, transInfo,
  getSingleLandApplication, landInfo, getSingleBuildingKind, kindOfBuildingInfo,
  type }) {

  const formatPeriod = (val) => {
    return val
      ? val
        .replace("1", "1ST QUARTER")
        .replace("2", "2ND QUARTER")
        .replace("3", "3RD QUARTER")
        .replace("4", "4TH QUARTER")
      : "---";
  };

  const setModal = useContext(ModalContext);

  const handleViewFaas = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewFaasModal data={applicationInfo} type={type} />,
      title: `View FAAS`,
      modalSize: 'modal-xl',
    });
  };

  const handleMemoranda = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <MemorandaModal
          memorandaData={item}
          type={type}
        />),
      title: 'Memoranda',
      modalSize: 'modal-xl',
    })
  }

  useEffect(() => {
    getSingleTransactCode(_.get(applicationInfo, 'attributes.rptax_transaction_code_id'));
    getSingleLandApplication(_.get(applicationInfo, 'attributes.rptax_land_application_id'));
    getSingleBuildingKind(_.get(applicationInfo, 'attributes.rptax_building_kind_id'));
  }, [])

  useEffect(() => {
    getSingleTransactCode(_.get(applicationInfo, 'attributes.rptax_transaction_code_id'));
    getSingleLandApplication(_.get(applicationInfo, 'attributes.rptax_land_application_id'));
    getSingleBuildingKind(_.get(applicationInfo, 'attributes.rptax_building_kind_id'));
  }, [applicationInfo])

  const handleViewTaxDeclaration = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewTaxDeclarationModal data={applicationInfo} type={type} />,
      title: `View Tax Declaration`,
      modalSize: 'modal-xl',
    });
  };

  return (
    <>
      <div className="row p-3">
        <div className="d-flex ml-auto mb-3 mr-1">
          <div className="form-input-group mr-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
              type="button"
              onClick={handleViewTaxDeclaration}
            >
              Tax Declaration
            </button>
          </div>
          <div className="form-input-group mr-2">
            <button
              // disabled={_.get(data, 'attributes.status') !== 'POSTED'}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
              type="button"
              onClick={handleViewFaas}
            >
              FAAS
            </button>
          </div>
          <div className="form-input-group mr-2">
            <button
              type="button"
              onClick={handleMemoranda(applicationInfo)}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
            >
              Memoranda&nbsp;
            </button>
          </div>
        </div>
        <div className="col-12 mt-3">
          <table className="transaction-table table table-borderless table-sm table-striped">
            <tbody>
              <TransactionRow
                title="Application Status"
                value={_.get(applicationInfo, 'attributes.status')}
                addClass
              />
              {applicationInfo?.attributes?.change_code_name === 'SUBDIVISION' &&
                _.get(applicationInfo, 'attributes.status') === 'CANCELLED' && (
                  <TransactionRow
                    title="Remaining Area"
                    value={_.get(applicationInfo, 'attributes.total_remaining_area') || '0'}
                  />
                )}
              <TransactionRow
                title="Transaction Code"
                value={_.get(transInfo, 'attributes.name') || '--'}
              />
              <TransactionRow
                title="ARP No."
                value={_.get(applicationInfo, 'attributes.arp_no') || '--'}
              />
              <TransactionRow
                title="TDN/ARP No."
                value={_.get(applicationInfo, 'attributes.tdn') || '--'}
              />
              <TransactionRow
                title="Building Kind"
                value={_.get(kindOfBuildingInfo, 'attributes.name') || '--'}
              />
              <TransactionRow
                title="Building Permit No."
                value={_.get(applicationInfo, 'attributes.building_permit_no') || '--'}
              />
              <TransactionRow
                title="Condominium Certificate Title"
                value={_.get(applicationInfo, 'attributes.condominium_certificate_title') || '--'}
              />
              <TransactionRow
                title="PIN"
                value={_.get(applicationInfo, 'attributes.pin') || '--'}
              />
              <TransactionRow
                title="Land Application"
                value={_.get(landInfo, 'attributes.pin') || '--'}
              />
              <TransactionRow
                title="Structural Type"
                value={_.get(applicationInfo, 'attributes.rptax_building_structural_type') || '--'}
              />
              <TransactionRow
                title="Date Issued"
                value={_.get(applicationInfo, 'attributes.date_issued') || '--'}
              />
              <TransactionRow
                title="Certificate Completion Issued On"
                value={_.get(applicationInfo, 'attributes.certificate_completion_issued_on') || '--'}
              />
              <TransactionRow
                title="Date Constructed Completed"
                value={_.get(applicationInfo, 'attributes.date_constructed_completed') || '--'}
              />
            </tbody>
          </table>
        </div>
        <hr />
        <div className="col-12 mt-3">
          <table className="transaction-table table table-borderless table-sm table-striped">
            <tbody>
              <TransactionRow
                title="Certificate Occupancy Issued On"
                value={_.get(applicationInfo, 'attributes.certificate_occupancy_issued_on') || '--'}
              />
              <TransactionRow
                title="Date Occupied"
                value={_.get(applicationInfo, 'attributes.date_occupied') || '--'}
              />
              <TransactionRow
                title="No of Storeys"
                value={_.get(applicationInfo, 'attributes.no_of_storeys') || '--'}
              />
              <TransactionRow
                title="Effectivity of Assessment/Reassessment Quarter"
                value={formatPeriod(_.get(applicationInfo, 'attributes.effectivity_of_assessment_reassessment_qtr')) || '--'}
              />
              <TransactionRow
                title="Registered"
                value={_.get(applicationInfo, 'attributes.registered') || '--'}
              />
              <TransactionRow
                title="Building Age"
                value={_.get(applicationInfo, 'attributes.building_age') || '--'}
              />
              <TransactionRow
                title="Total Floor Area"
                value={_.get(applicationInfo, 'attributes.total_floor_area') || '--'}
              />
              <TransactionRow
                title="Effectivity of Assessment/Reassessment Year"
                value={_.get(applicationInfo, 'attributes.effectivity_of_assessment_reassessment_yr') || '--'}
              />
            </tbody>
          </table>
        </div>
        <hr />
        <div className="col-12 mt-3">
          <table className="transaction-table table table-borderless table-sm table-striped">
            <tbody>
              <TransactionRow
                title="Appraised/Assessed At"
                value={_.get(applicationInfo, 'attributes.appraised_assessed_at') || '--'}
              />
              <TransactionRow
                title="Recommended At"
                value={_.get(applicationInfo, 'attributes.recommending_at') || '--'}
              />
              <TransactionRow
                title="Appraised/Assessed By"
                value={_.get(applicationInfo, 'attributes.appraised_assessed_by') || '--'}
              />
              <TransactionRow
                title="Recommended By"
                value={_.get(applicationInfo, 'attributes.recommending_by') || '--'}
              />
              <TransactionRow
                title="Approved By"
                value={_.get(applicationInfo, 'attributes.approved_by') || '--'}
              />
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

Information.defaultProps = {
  type: '',
  applicationInfo: {}
};

Information.propTypes = {
  applicationInfo: PropTypes.instanceOf(Object),
  getSingleTransactCode: PropTypes.instanceOf(Function).isRequired,
  transInfo: PropTypes.instanceOf(Object).isRequired,
  getSingleLandApplication: PropTypes.instanceOf(Function).isRequired,
  landInfo: PropTypes.instanceOf(Object).isRequired,
  getSingleBuildingKind: PropTypes.instanceOf(Function).isRequired,
  kindOfBuildingInfo: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
}

const mapStateToProps = ({ api }) => ({
  transInfo: _.get(api, `${c.GET_SINGLE_TRANSACT_CODE}.item`) || {},
  landInfo: _.get(api, `${c.GET_SINGLE_LAND_APPLICATION}.item`) || {},
  kindOfBuildingInfo: _.get(api, `${c.GET_SINGLE_BUILDING_KIND}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Information);